<div id="agents-row-container">
  <!-- Checkbox -->
  <mat-checkbox
    *ngIf="this.agent.infoCompleta; else infoincompleta"
    [id]="this.agent.id"
    class="check"
    [checked]="this.agent.checked"
    color="primary"
    (change)="onCheckboxChange($event.checked)"
  >
  </mat-checkbox>
  <ng-template #infoincompleta>
    <div class="check-error" matTooltip="Información incompleta">
      <qr-icon name="error" color="error-700"></qr-icon>
    </div>
  </ng-template>
  <!-- Agente - Nombre -->
  <div id="agent">
    <p id="name" class="subheading-01-semi-bold">
      {{ this.agent.nombre }} {{ this.agent.apellido }}
    </p>
  </div>
  <!-- TIPO -->
  <div id="type">
    <p class="font">{{ this.arrayConstants[this.agent.tipoAgente] }}</p>
  </div>
  <!-- FACTURA -->
  <div id="invoice">
    <p class="font">
      {{ this.arrayConstants["factura"][this.agent.cbteTipo] }}
    </p>
  </div>
  <!-- IVA -->
  <div id="iva">
    <p class="font">
      {{ this.arrayConstants["tipo"][this.agent.condicionIVA] }}
    </p>
  </div>
  <!-- CUIT -->
  <div id="cuit">
    <p class="font">{{ this.cuitWithFormat }}</p>
  </div>
</div>
